export default __webpack_public_path__ + "static/Workout-With-A-View-Tough-Mudder-Houston-02590f68189ddd00675e20ab1dcd632b.jpg";